module.exports = __webpack_public_path__ + "static/media/land_paars.7055e0f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/land_paars.svg
// module id = 609
// module chunks = 0